exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-breadcrumb .v-toolbar__content{padding:0}", ""]);

// exports
